'use client';

import { ApiKeys, fetcher } from '@insta-club/api';
import { Container } from '@insta-club/components';
import ContentWrapper from '@insta-club/components/common/contentWrapper';
import { CategoriesResponse, CoursesCategoriesResponse } from '@insta-club/models';
import { GuidesButton } from '@insta-club/ui';
import Image from 'next/image';
import Link from 'next/link';
import { FreeMode } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import useSWR from 'swr';
import Coaches from './coaches';
import EducationalPosts from './educational-posts';
import LatestAcademyVideo from './latest-academy-video';
import LatestCourse from './latest-course';

// const Story = dynamic(() => import('./story'), { ssr: false });

function Feed() {
    const { data: categories, isLoading } = useSWR<CategoriesResponse>(ApiKeys.CATEGORIES, (url: string) =>
        fetcher(url, 'dashboard', 'GET')
    );

    const { data: coursesCategories } = useSWR<CoursesCategoriesResponse>(ApiKeys.COURSES_CATEGORIES, (url: string) =>
        fetcher(url, 'dashboard', 'POST')
    );

    return (
        <>
            <Container hasHeader className='mb-4'>
                <div className='flex items-center justify-between'>
                    <span className='text-lg font-bold'>آکادمی اینستاکلاب</span>
                    <GuidesButton guideKey='academy_guide' />
                </div>
            </Container>
            {/* <Story /> */}
            {/* <OfferBanner /> */}
            {/* <Search /> */}
            <LatestCourse />

            {coursesCategories?.data?.length && (
                <ContentWrapper title='دسته‌بدی های دوره آموزشی'>
                    <Swiper
                        modules={[FreeMode]}
                        freeMode
                        slidesPerView='auto'
                        spaceBetween={12}
                        slidesOffsetBefore={24}
                        slidesOffsetAfter={24}
                        className='w-full'
                        style={{ overflow: 'hidden' }} // ← key fix
                        wrapperClass='items-stretch'
                    >
                        {coursesCategories?.data?.map((category) => (
                            <SwiperSlide key={category.id} className='w-32!'>
                                <Link href={`/courses?category_id=${category.id}`}>
                                    <div className='group bg-primary-50 flex cursor-pointer flex-col gap-2 rounded-2xl border border-gray-100 p-2 transition-all duration-300 hover:-translate-y-0.5'>
                                        <div className='relative aspect-square w-full overflow-hidden rounded-xl bg-gray-100'>
                                            <Image
                                                fill
                                                src={category.image}
                                                alt={category.title}
                                                className='object-cover transition-transform duration-500 group-hover:scale-105'
                                            />
                                        </div>
                                        <span className='line-clamp-1 px-0.5 text-center text-xs leading-tight font-semibold text-gray-700'>
                                            {category.title}
                                        </span>
                                    </div>
                                </Link>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </ContentWrapper>
            )}

            <LatestAcademyVideo />
            <Coaches />
            {/* Videos By Category */}
            {!isLoading && categories && <EducationalPosts categories={categories?.data} />}
        </>
    );
}

export default Feed;

